import { render, staticRenderFns } from "./House.vue?vue&type=template&id=ae0d0fe2&"
import script from "./House.vue?vue&type=script&lang=js&"
export * from "./House.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports